import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from 'react-redux'
import { Link, useParams } from "react-router-dom"
import { SimpleGrid, Box, Button, Flex, Image, Text, Card, CardHeader, Heading, InputGroup, Input, InputRightElement } from '@chakra-ui/react'
import Layout from '../layout'
import { SearchIcon } from '@chakra-ui/icons'
import empty from '../multimedia/icons/Towing-pana.svg'
import { fetchActiveBolsa } from "../actions"
import { getBolsas } from "../reducers"


const BolsaEmpleo = () => {

    const dispatch = useDispatch()
    const [searchbar, setSearchBar] = useState('')

    useEffect(() => {
        dispatch(fetchActiveBolsa())
    }, [])

    const posts = useSelector(state => getBolsas(state))

    const filterBar = (e) => {
        setSearchBar(e.target.value)
        if (searchbar.length >= 3) {
            // this.props.filterBar(this.state.searchbar)
            console.log("hago busqueda")
        }
    }

    const clearFliter = () => {
        setSearchBar("")
    }

    return (
        <Layout>
            <Box p={3} mb={3}>
                <Flex maxW={"1400px"} justifyContent={"center"} m={"auto"}>
                    <InputGroup>
                        <Input placeholder='Buscar por empleo' bg={"white"} size='lg' value={searchbar} onChange={filterBar} />
                        <InputRightElement children={<SearchIcon color={"GrayText"} />} />
                    </InputGroup>
                </Flex>
            </Box>
            <Box maxW={"1400px"} minHeight={"500px"} flexDir={{ base: 'column', md: 'row' }} p={4} m={"auto"} mt={"2rem"} mb={"2rem"}>

                <Heading >Bolsa de empleo</Heading>
                {posts.length > 0 ?
                    <SimpleGrid columns={1} spacing={"10"} p={"16px"}>
                        {posts.map(post =>
                        <Link to={`bolsa-empleo/${post.id}/detalle`} key={post.id}>
                            <Card key={post.id}>
                                <CardHeader>
                                    {post.title}
                                </CardHeader>
                            </Card>
                        </Link>
                        )}
                    </SimpleGrid>
                    :
                    <Box width={{ base: 'full', lg: '75%' }} p={3} textAlign={"center"}>
                        <Image src={empty} alt="Vacio" m={"auto"} maxH={"400px"} />
                        <Text>El empleo que buscas no se encuentra, busca nuevamente</Text>
                        <Button size={"sm"} variant='outline' colorScheme={"green"} onClick={clearFliter} >Limpiar filtro</Button>
                    </Box>
                }
            </Box>

        </Layout >
    )
}

export default BolsaEmpleo